import React, { useState, useEffect } from "react";
import axios from "axios";
import { decodeToken } from "react-jwt";
import { Card, Form, Button, Alert, Spinner } from "react-bootstrap";
import "../../App.css";
import { useParams } from "react-router-dom";
import { log } from "util";
import { validate } from "react-email-validator";

export default function CreateMessage() {
  let { id } = useParams();
  const [message, setMessage] = React.useState("");
  const [isValidated, setisValidated] = React.useState("");
  const [error, setError] = useState("");
  const [show, setShow] = useState(false);
  const [isLoading, setLoadingState] = useState(false);
  const [email, setEmail] = React.useState("");
  const [emailValidation, setEmailValidation] = useState("");
  const [variant, setVariant] = useState("danger");

  useEffect(() => {
    if (localStorage.getItem("userToken")) {
      setLoadingState(true);
      axios
        .post("https://secretsafe-backend.onrender.com/vertify-token", {
          token: localStorage.getItem("userToken"),
        })
        .then((response, err) => {
          if (err) {
          } else {
            console.log(response);
            if (response.id === id) {
              window.location.replace("/");
              setLoadingState(false);
            } else {
              setLoadingState(false);
            }
          }
        });
    }
  }, []);

  document.title = "Create Message | SecretSafe";

  const submitMsg = (e) => {
    e.preventDefault();
    if (validate(email)) {
      setEmailValidation(false);
      if (message.length > 1) {
        setEmailValidation(false);
        setisValidated(false);
        setLoadingState(true);
        axios
          .post("https://secretsafe-backend.onrender.com/create-message", {
            id,
            email,
            messageReq: message,
          })
          .then((response) => {
            setLoadingState(false);
            afterRequest(response);
          });
      } else {
        setisValidated(true);
      }
    } else {
      setEmailValidation(true);
    }
    function afterRequest(response) {
      if (response.data.response) {
        setVariant("success");
        setError(response.data.response);
        setShow(true);
      }
      if (response.data.error) {
        setVariant("danger");
        setError(response.data.error);
        setShow(true);
      }
    }
  };
  return (
    <Card
      style={{ alignItems: "center", padding: "15px", marginTop: "10px" }}
      className="mx-auto card__"
    >
      <Alert show={show} variant={variant}>
        {error}
      </Alert>
      {isLoading ? (
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      ) : (
        <>
          <Card.Body
            style={{
              fontSize: "25px",
              textAlign: "center",
              paddingBottom: "0px",
            }}
          >
            Message your friend Secretly 😉, they will never know who messaged
            them.😅
          </Card.Body>
          <Card.Body
            style={{
              fontSize: "35px",
              textAlign: "center",
              paddingTop: "5px",
              paddingBottom: "2px",
            }}
          >
            🤣
          </Card.Body>
          <Card style={{ width: "100%", border: "none", marginTop: "10px" }}>
            <Form.Control
              type="email"
              onChange={(input) => setEmail(input.target.value)}
              value={email}
              required
              placeholder="Email Address"
              style={{ marginRight: "40px", border: "3px #7F7CAF solid" }}
            />
            <Form.Text>
              Your email address is just used for a response. It's encrypted, so
              even we can't see it.
            </Form.Text>
            {emailValidation ? (
              <Form.Text style={{ color: "#dc3545", textAlign: "center" }}>
                Please enter a valid email
              </Form.Text>
            ) : (
              <></>
            )}
            <Form.Control
              onChange={(value) => setMessage(value.target.value)}
              as="textarea"
              placeholder="Write your secret message here"
              type="name"
              style={{
                marginTop: "15px",
                border: "3px #7F7CAF solid",
                height: "100px",
                width: "100%",
                overflow: "scroll",
              }}
            />
            {isValidated ? (
              <Form.Text style={{ color: "#dc3545", textAlign: "center" }}>
                Your message should longer than 10 characters
              </Form.Text>
            ) : (
              <></>
            )}
            <Button
              style={{
                marginTop: "20px",
                background: "#7F7CAF",
                border: "none",
              }}
              onClick={(e) => {
                submitMsg(e);
              }}
            >
              Send Secret Message 😎
            </Button>
          </Card>
        </>
      )}
    </Card>
  );
}
